<ng-container *transloco="let t; read: 'ime.manufacturing.ime-list'">
  <div *ngIf="(filter$ | async) as filter">
    <app-toolbar>
      <app-breadcrumbs>
      </app-breadcrumbs>
      <app-page-search class="me-auto" [(searchString)]="filter.Global" [(showFilters)]="filter.AdvancedFilter" (searchStringChange)="filter$.next(filter)"></app-page-search>
      <div class="btn-toolbar btn-max-content flex-nowrap justify-content-end">
        <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="load()">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#arrow-path">
          </svg>
          {{t('Load')}}
        </button>
      </div>
    </app-toolbar>
    <p-table styleClass="p-datatable-sm p-datatable-striped"
             [columns]="allColumns | filterBy: ['IsSelected']: true"
             [value]="filteredData$ | async"
             dataKey="Id"
             [lazy]="true"
             [lazyLoadOnInit]="false"
             [paginator]="true"
             [rows]="page.Size"
             [rowsPerPageOptions]="rowsPerPageOptions"
             [showCurrentPageReport]="true"
             [totalRecords]="page.Total"
             currentPageReportTemplate="{first} to {last} of {totalRecords}"
             [first]="page.Number * page.Size"
             (onSort)="onSort($event)"
             (onPage)="onPage($event)">
      <ng-template pTemplate="header" let-columns>
        <ng-container *ngLet="filter$ | async as filter">
          <tr>
            <ng-container *ngFor="let column of columns">
              <ng-container *ngIf="[columnIdentifiers.ProcessSelectorSpecs, columnIdentifiers.OperationSpecs, columnIdentifiers.TaskSelectorSpecs, columnIdentifiers.InstructionSpecs, columnIdentifiers.Item].includes(column.Identifier); else sortableColumn">
                <th class="text-wrap text-break" [style.width]="column.Width + 'rem'">{{column.Name | transloco}}</th>
              </ng-container>
              <ng-template #sortableColumn>
                <th pSortableColumn="{{column.Code}}" class="text-wrap text-break" [style.width]="column.Width + 'rem'">
                  {{column.Name | transloco}}
                  <p-sortIcon field="{{column.Code}}"></p-sortIcon>
                </th>
              </ng-template>
            </ng-container>
            <th>
              <div class="dropdown" ngbDropdown [autoClose]="'outside'" [placement]="['bottom-right', 'bottom-left']">
                <button class="btn btn-sm btn-outline-primary dropdown-toggle-without-arrow" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#bars-3"></svg>
                </button>
                <div ngbDropdownMenu>
                  <button ngbDropdownItem (click)="saveFilter(filter)">
                    {{t('Save filter')}}
                  </button>
                  <div class="dropdown-divider"></div>
                  <h6 class="dropdown-header">{{t('Columns')}}</h6>
                  <button *ngFor="let column of allColumns" ngbDropdownItem [ngClass]="{'active': column.IsSelected}" (click)="toggleColumn(column)">
                    {{column.Name | transloco}}
                  </button>
                  <button ngbDropdownItem (click)="toggleAllColumns()">
                    {{t('Select all')}}
                  </button>
                </div>
              </div>
            </th>
          </tr>
          <tr *ngIf="filter.AdvancedFilter">
            <th class="p-1 mx-wx-256" *ngFor="let column of columns">
              <ng-container [ngSwitch]="column.Identifier">
                <ng-container *ngSwitchCase="columnIdentifiers.Target">
                  <div class="bl-3 border-primary">
                    <ng-container [ngTemplateOutlet]="selectFilter"
                                  [ngTemplateOutletContext]="{filterModel: filter.Data.TargetItemGroupIds, items: itemGroupsQuery.getAll$ | async, name: 'TargetItemGroupIds', bindLabel: 'DisplayName', bindValue: 'Id', placeholder: t('Target Item Group')}">
                    </ng-container>
                  </div>
                  <div class="bl-3 border-secondary mb-1">
                    <app-item-picker [(ngModel)]="filter.Data.TargetItemIds" [multiple]="true" (ngModelChange)="filter.Data.TargetItemIds = $event;" [placeholder]="t('Target Item')" [showEdit]="false"></app-item-picker>
                  </div>
                  <ng-container [ngTemplateOutlet]="selectFilter"
                                [ngTemplateOutletContext]="{filterModel: filter.Data.TargetTypes, items: targetTypes, name: 'TargetTypes', bindLabel: 'Name', bindValue: 'Code', placeholder: t('Target type')}">
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.ProcessSelector" [ngTemplateOutlet]="selectFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.ProcessSelectorCodes, items: [], name: 'ProcessSelectorCodes', cssClass: 'tags-only', isOpen: false}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.ProcessSelectorValidCondition" [ngTemplateOutlet]="textFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.ProcessSelectorValidCondition, name: columnIdentifiers[columnIdentifiers.ProcessSelectorValidCondition]}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.ProcessSelectorSpecs" [ngTemplateOutlet]="specFilter"
                              [ngTemplateOutletContext]="{specs: filter.Data.ProcessSelectorSpecs, name: columnIdentifiers[columnIdentifiers.ProcessSelectorSpecs]}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.ProcessNumber" [ngTemplateOutlet]="selectFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.ProcessNumbers, items: [], name: 'ProcessNumbers', cssClass: 'tags-only', isOpen: false}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.Process" [ngTemplateOutlet]="selectFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.ProcessIds, items: processesQuery.getAll$ | async, name: 'ProcessIds', bindLabel: 'Code', bindValue: 'Id'}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.ProcessValidCondition" [ngTemplateOutlet]="textFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.ProcessValidCondition, name: columnIdentifiers[columnIdentifiers.ProcessValidCondition]}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.OperationSpecs" [ngTemplateOutlet]="specFilter"
                              [ngTemplateOutletContext]="{specs: filter.Data.OperationSpecs, name: columnIdentifiers[columnIdentifiers.OperationSpecs]}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.Customer" [ngTemplateOutlet]="selectFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.Customers, items: [], name: 'Customers', cssClass: 'tags-only', isOpen: false}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.TaskSelector" [ngTemplateOutlet]="selectFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.TaskSelectorCodes, items: [], name: 'TaskSelectorCodes', cssClass: 'tags-only', isOpen: false}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.TaskSelectorValidCondition" [ngTemplateOutlet]="textFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.TaskSelectorValidCondition, name: columnIdentifiers[columnIdentifiers.TaskSelectorValidCondition]}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.TaskSelectorSpecs" [ngTemplateOutlet]="specFilter"
                              [ngTemplateOutletContext]="{specs: filter.Data.TaskSelectorSpecs, name: columnIdentifiers[columnIdentifiers.TaskSelectorSpecs]}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.Code" [ngTemplateOutlet]="selectFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.InstructionCodes, items: [], name: 'InstructionCodes', cssClass: 'tags-only', isOpen: false}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.Type" [ngTemplateOutlet]="selectFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.InstructionTypes, items: instructionTypes, name: 'InstructionTypes', bindLabel: 'Name', bindValue: 'Code'}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.Item">
                  <div class="bl-3 border-primary d-flex">
                    <ng-container *ngIf="!filter.Data.InstructionItemGroupIdExists" [ngTemplateOutlet]="selectFilter"
                                  [ngTemplateOutletContext]="{filterModel: filter.Data.InstructionItemGroupIds, items: itemGroupsWithEmpty$ | async, name: 'InstructionItemGroupIds', bindLabel: 'DisplayName', bindValue: 'Id', placeholder: t('Item Group')}">
                    </ng-container>
                    <div class="d-flex flex-nowrap custom-control custom-checkbox my-auto ms-1">
                      <input type="checkbox" class="custom-control-input" id="selectionInstructionItemGroupIdExists" [checked]="filter.Data.InstructionItemGroupIdExists" (change)="filter.Data.InstructionItemGroupIdExists = !filter.Data.InstructionItemGroupIdExists; filter$.next(filter)" [title]="t('Has any item group')">
                      <label *ngIf="filter.Data.InstructionItemGroupIdExists" class="ms-1" for="selectionInstructionItemGroupIdExists">
                        <span>{{t('Has any item group')}}</span>
                      </label>
                    </div>
                  </div>
                  <div class="bl-3 border-secondary d-flex">
                    <ng-container *ngIf="!filter.Data.InstructionItemIdExists" [ngTemplateOutlet]="selectFilter"
                                  [ngTemplateOutletContext]="{filterModel: filter.Data.InstructionItemIds, items: itemsWithEmpty$ | async, name: 'InstructionItemIds', bindLabel: 'DisplayName', bindValue: 'Id', placeholder: t('Item')}">
                    </ng-container>
                    <div class="d-flex flex-nowrap custom-control custom-checkbox my-auto ms-1">
                      <input type="checkbox" class="custom-control-input" id="selectionInstructionItemIdExists" [checked]="filter.Data.InstructionItemIdExists" (change)="filter.Data.InstructionItemIdExists = !filter.Data.InstructionItemIdExists; filter$.next(filter)" [title]="t('Has any item')">
                      <label *ngIf="filter.Data.InstructionItemIdExists" class="ms-1" for="selectionInstructionItemIdExists">
                        <span>{{t('Has any item')}}</span>
                      </label>
                    </div>
                  </div>
                  <div class="bl-3 border-left-green-600 d-flex flex-nowrap mb-1">
                    <ng-container *ngIf="!filter.Data.InstructionResourceTemplateIdExists">
                      <app-resource-picker class="w-100" [(ngModel)]="filter.Data.InstructionResourceTemplateIds" [multiple]="true" sortField="Code" (ngModelChange)="filter.Data.InstructionResourceTemplateIds = $event" [showEdit]="false" [placeholder]="t('Resource Template')"></app-resource-picker>
                    </ng-container>
                    <div class="d-flex flex-nowrap custom-control custom-checkbox my-auto ms-1">
                      <input type="checkbox" class="custom-control-input" id="selectionInstructionResourceTemplateIdExists" [checked]="filter.Data.InstructionResourceTemplateIdExists" (change)="filter.Data.InstructionResourceTemplateIdExists = !filter.Data.InstructionResourceTemplateIdExists; filter$.next(filter)" [title]="t('Has any resource template')">
                      <label *ngIf="filter.Data.InstructionResourceTemplateIdExists" class="ms-1" for="selectionInstructionResourceTemplateIdExists">
                        <span>{{t('Has any resource template')}}</span>
                      </label>
                    </div>
                  </div>
                  <div class="bl-3 border-info d-flex flex-nowrap">
                    <ng-container *ngIf="!filter.Data.InstructionResourceIdExists">
                      <app-resource-picker class="w-100" [(ngModel)]="filter.Data.InstructionResourceIds" [multiple]="true" sortField="Code" (ngModelChange)="filter.Data.InstructionResourceIds = $event" [showEdit]="false" [placeholder]="t('Resource')"></app-resource-picker>
                    </ng-container>

                    <div class="custom-control custom-checkbox my-auto ms-1">
                      <input type="checkbox" class="custom-control-input" id="selectionInstructionResourceIdExists" [checked]="filter.Data.InstructionResourceIdExists" (change)="filter.Data.InstructionResourceIdExists = !filter.Data.InstructionResourceIdExists; filter$.next(filter)" [title]="t('Has any resource')">
                      <label *ngIf="filter.Data.InstructionResourceIdExists" class="ms-1" for="selectionInstructionResourceIdExists">
                        <span>{{t('Has any resource')}}</span>
                      </label>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.PrevNumber" [ngTemplateOutlet]="selectFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.PrevNumbers, items: processesQuery.getAll$ | async, name: 'PrevNumbers', bindLabel: 'Number', bindValue: 'Number'}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.InstructionValidCondition" [ngTemplateOutlet]="textFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.InstructionValidCondition, name: columnIdentifiers[columnIdentifiers.InstructionValidCondition]}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.Valid" [ngTemplateOutlet]="dateRangeFilter">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.InstructionSpecs" [ngTemplateOutlet]="specFilter"
                              [ngTemplateOutletContext]="{specs: filter.Data.InstructionSpecs, name: columnIdentifiers[columnIdentifiers.InstructionSpecs]}">
                </ng-container>
                <ng-container *ngSwitchCase="columnIdentifiers.TimeConstraintMethodClv" [ngTemplateOutlet]="selectFilter"
                              [ngTemplateOutletContext]="{filterModel: filter.Data.TimeConstraintMethods, items: classificatorValuesQuery.timeConstraintMethods$ | async, name: 'TimeConstraintMethods', bindLabel: 'Code', bindValue: 'Id'}">
                </ng-container>
              </ng-container>
              <ng-template #selectFilter let-filterModel="filterModel" let-items="items" let-name="name" let-bindLabel="bindLabel" let-bindValue="bindValue" let-cssClass="cssClass" let-isOpen="isOpen" let-placeholder="placeholder">
                <ng-select class="select-sm form-control compact mb-1 dropdown-auto-width"
                           virtualScroll="true"
                           [ngClass]="cssClass" appendTo="body"
                           [placeholder]="placeholder ?? ''"
                           [items]="items" name="{{name}}"
                           [multiple]="true"
                           [ngModel]="filterModel"
                           [searchFn]="searchFn"
                           [bindLabel]="bindLabel"
                           [bindValue]="bindValue"
                           [addTag]="true"
                           [selectOnTab]="true"
                           [isOpen]="isOpen"
                           (ngModelChange)="updateFilter(name, $event)"></ng-select>
              </ng-template>
              <ng-template #specFilter let-specs="specs" let-name="name">
                <div>
                  <button class="btn btn-sm btn-outline-primary me-1" [ngbPopover]="specsContent" container="body" popoverClass="min-wx-384" [autoClose]="false" triggers="manual" #p="ngbPopover"
                          (click)="p.toggle()">
                    <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
                  </button>
                </div>
                <div class="col-12 ps-0">
                  <app-spec-lines-view [specs]="specs"></app-spec-lines-view>
                </div>
                <ng-template #specsContent>
                  <form>
                    <app-spec-values-list [specs]="specs"
                                          [hasSpecFilterOptions]="false" [showLabel]="false"
                                          (onLineChanged)="filter$.next(filter)"
                                          (onLineAdd)="addSpec(filter, name)" cssClass="col-md-12"></app-spec-values-list>
                  </form>
                </ng-template>
              </ng-template>
              <ng-template #textFilter let-filterModel="filterModel" let-name="name">
                <input type="search" class="form-control compact tags-only" name="{{name}}" [ngModel]="filterModel" (ngModelChange)="filter.Data[name] = $event" (change)="filter$.next(filter)">
              </ng-template>
              <ng-template #dateRangeFilter>
                <div class="input-group input-group-sm mb-1">
                  <input class="form-control" id="fromFilter" name="fromFilter" placeHolder="From" [(ngModel)]="filter.Data['ValidFrom']" (ngModelChange)="filter$.next(filter)" ngbDatepicker #dFrom="ngbDatepicker">
                  <button class="btn btn-outline-primary" (click)="dFrom.toggle()" type="button">
                    <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#calendar-days">
                    </svg>
                  </button>
                </div>
                <div class="input-group input-group-sm">
                  <input class="form-control" id="toFilter" name="toFilter" placeHolder="To" [(ngModel)]="filter.Data['ValidTo']" (ngModelChange)="filter$.next(filter)" ngbDatepicker #dTo="ngbDatepicker">
                  <button class="btn btn-outline-primary" (click)="dTo.toggle()" type="button">
                    <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#calendar-days">
                    </svg>
                  </button>
                </div>
              </ng-template>
            </th>
            <th>
            </th>
          </tr>
        </ng-container>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr>
          <td *ngFor="let column of columns" class="text-wrap text-break">
            <ng-container [ngSwitch]="column.Identifier">
              <ng-container *ngSwitchCase="columnIdentifiers.Target">
                <a href [routerLink]="row.TargetPath">{{row.Target}}</a>
              </ng-container>
              <ng-container *ngSwitchCase="columnIdentifiers.OperationSpecs">
                <app-spec-lines-view [specs]="row[column.Code]"></app-spec-lines-view>
              </ng-container>
              <ng-container *ngSwitchCase="columnIdentifiers.InstructionSpecs">
                <app-spec-lines-view [specs]="row[column.Code]"></app-spec-lines-view>
              </ng-container>
              <ng-container *ngSwitchCase="columnIdentifiers.ProcessSelectorSpecs">
                <app-spec-lines-view [specs]="row[column.Code]"></app-spec-lines-view>
              </ng-container>
              <ng-container *ngSwitchCase="columnIdentifiers.TaskSelectorSpecs">
                <app-spec-lines-view [specs]="row[column.Code]"></app-spec-lines-view>
              </ng-container>
              <ng-container *ngSwitchCase="columnIdentifiers.Item">
                <div class="bl-3 border-primary ps-1" *ngIf="row.InstructionItemGroup" [title]="t('Item Group')">
                  {{row.InstructionItemGroup}}
                </div>
                <div class="bl-3 border-secondary ps-1" *ngIf="row.InstructionItem" [title]="t('Item')">
                  {{row.InstructionItem}}
                </div>
                <div class="bl-3 border-left-green-600 ps-1" *ngIf="row.InstructionResourceTemplate" [title]="t('Resource Template')">
                  {{row.InstructionResourceTemplate}}
                </div>
                <div class="bl-3 border-info ps-1" *ngIf="row.InstructionResources" [title]="t('Resource')">
                  {{row.InstructionResources}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="columnIdentifiers.TimeConstraintMethodClv">
                {{(classificatorValuesQuery.timeConstraintMethods$ | async | find: 'Id': row.TimeConstraintMethodClv)?.Code}}
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{row[column.Code]}}
              </ng-container>
            </ng-container>
          </td>
          <td>
            <button *ngIf="!row.ConfigurationId" class="btn btn-sm btn-outline-primary me-1" (click)="open(row)">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</ng-container>
